<template>
  <div class="language-switcher">
    <vue-country-code
      @onSelect="onSelect"
      :defaultCountry="defaultCountry"
      :onlyCountries="['nl', 'gb', 'de', 'fr', 'es', 'se', 'dk', 'it']"
      :dropdownOptions="{ disabledDialCode: true }"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Trans } from "@/plugins/Translation";
// import "vue-country-code/dist/vue-country-code.css";

export default {
  data() {
    return {
      //defaultCountry: 'nl'
    };
  },
  computed: {
    defaultCountry() {
      let lang;
      if (localStorage.getItem("lang")) {
        lang = localStorage.getItem("lang");
        if (lang === "en") lang = "gb";
        if (lang === "de") lang = "de";
        if (lang === "fr") lang = "fr";
        if (lang === "es") lang = "es";
        if (lang === "se") lang = "se";
        if (lang === "da") lang = "dk";
        if (lang === "it") lang = "it";
      } else lang = "nl";

      return lang;
    },
  },
  methods: {
    /* eslint-disable */ ...mapActions(["SET_LANG"]),

    onSelect({ name, iso2, dialCode }) {
      let lang = iso2.toLowerCase();
      if (lang == "gb") lang = "en";
      if (lang === "dk") lang = "da";

      if (localStorage.getItem("userName")) {
        this.SET_LANG(lang);
      }

      localStorage.setItem("lang", lang);
      const to = this.$router.resolve({ params: { lang } });
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location);
      });
    },
  },
};
</script>

<style>
.language-switcher .vue-country-select .current span:not(.dropdown-arrow) {
  display: none;
}

.language-switcher .vue-country-select .dropdown-list li span {
  display: none;
}
</style>
